export default {

    methods: {
        extractAgencyFromOffer (contract) {
            return contract.offer.distributed_product.agency
        },

        extractAgenciesFromOffer (contracts) {
            return _.map(contracts, contract => ({
                agency: this.extractAgencyFromOffer(contract),
                ...contract
            }))
        },

        extractMailOption (order) {
            const {options} = order.suborders[0],
                option = this.findMailOption(options)
            // debugger
            return option
        },

        findMailOption (options, deep = false) {
            return _.find(options, (option) => {
                const opt = deep ? option.option : option
                return opt.mail_forwarded || opt.mail_kept
            })
        },

        findHotlineOption (options, deep = false) {
            return _.find(options, (option) => {
                const opt = deep ? option.option : option
                return opt.custom_hotline || opt.simple_hotline
            })
        },

        isMailForwarded (option, deep = false) {
            const opt = deep ? option.option : option

            return opt.mail_forwarded
        },
        
        isMailScan (option, deep = false) {
            const opt = deep ? option.option : option

            return opt.mail_scan
        },

        isDomiciliation (contract) {
            return contract.type === "domiciliation_contract"
        },

        hasOfficeNumber (contract) {
            return Boolean(contract.office_number)
        },

        hasHotline(contract) {
            const {'contract_options': options} = contract,
                hotlineOption = this.findHotlineOption(options, true)
            return hotlineOption
        },
// A readapter
        normalizedContractState (contract) {
            const {'contract_options': options} = contract,
                mailOption = this.findMailOption(options, true)
            const isMailForwarded = mailOption ?
                this.isMailForwarded(mailOption.option) :
                false
            const isMailScan = mailOption ?
                this.isMailScan(mailOption.option) :
                false

            if (!options.length)
                return "Aucune Option"

            if (!mailOption)
                return "Pas d'Option de Courrier"

            // can be false     => no mailbox registered / mail forward option chosen
            // _      Number(x)

            const mailboxNumber = mailOption.option.mail_kept &&
                mailOption.hasOwnProperty('mail_kept_mailbox_number') &&
                mailOption.mail_kept_mailbox_number

            // debugger

            if (isMailScan)
                return "Scan du courrier"
            
            return isMailForwarded ?
                mailOption.option.name :
                mailboxNumber ?
                    `Mise à Dispo / BAL ${mailboxNumber}` :
                    "Mise à Dispo"
        },

        normalizedHotlineState(contract) {
            const hotlineOption = this.hasHotline(contract)

            if (hotlineOption === -1)
                return 'Pas de Permanence téléphonique'

            const phoneNumber = hotlineOption.hotline_phone,
                phoneStr = _.isNull(phoneNumber) ? '' : `: <br><span class="semi-bold">${phoneNumber}</span>`

            return hotlineOption.option.simple_hotline ?
                `Permanence téléphonique simple${phoneStr}` :
                `Permanence téléphonique personnalisée${phoneStr}`
        },

        redirectToContractDetails(contract)
        {
          this.$router.push({
            // path: '/customer',
            name:'contract-management',
            params :  {
                  id: contract.customer_id,
                  contractId: contract.id
                }
          })
          $('#closeOverlay').click()
        },

        normalizedOfficeState(contract) {
            return `Bureau: <span class="semi-bold">${contract.office_number}</span>`
        },

        contractWithInstruction(contract, instruction_name) {
            const proxy_instructions = ['postal', 'package_reception']

            // Proxy type instructions have specific treatments
            if ( _.includes(proxy_instructions, instruction_name) )
                return _.some(contract.proxies, function(proxy) { return proxy.type.name === instruction_name })
            else if ( contract[instruction_name] !== undefined )
                return contract[instruction_name]

            return false;
        },

        getFilteredContractsList(contracts) {
            return _.reject(contracts, function (contract) { return contract.start_date == contract.end_date; })
        }
    }
}



// WEBPACK FOOTER //
// ./client/mixins/contracts.js